/* Publish by EComposer at 2025-08-07 03:46:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fslwesp8m6d"]=  window.__ectimmers["ecom-fslwesp8m6d"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-fslwesp8m6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fslwesp8m6d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bz77qeym5nh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bz77qeym5nh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6fqych2s5kv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6fqych2s5kv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ekat9bcy61').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ekat9bcy61', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wbkq0f9cf8h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wbkq0f9cf8h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vywx96ifih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vywx96ifih', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hffq559ox98').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hffq559ox98', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-op0tjahae9g"]=  window.__ectimmers["ecom-op0tjahae9g"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-op0tjahae9g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-op0tjahae9g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zp8jn2inm48').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zp8jn2inm48', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sh51mswqiue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sh51mswqiue', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ds7z6gm1krj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ds7z6gm1krj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbaehwljqoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbaehwljqoi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-npvjn7isv8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-npvjn7isv8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);};window.addEventListener("load",()=>{
                let isAdmin = false;
                if(document.querySelector("#admin-bar-iframe")){
                    isAdmin = true;
                }
                if(!isAdmin) {
                    if(window.EComposerBrand) {
                        return;
                    } else {
                        window.EComposerBrand = true;
                    }
                }
                let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 11px","width: 100%","text-align: center","opacity: 1","text-indent: 0","color: rgba(18, 18, 18, 0.75)","background: transparent","opacity: 0.8",""].join(" !important;")),b.innerHTML="Built with <a style='color: currentColor;text-decoration: none;' href=\"https://ecomposer.io/?utm_source=client-site&utm_medium=footer&utm_campaign=footer_branding&utm_term=links&utm_content="+window.location.origin+"\" target=\"_blank\">EComposer</a>" + (isAdmin ? ". Contact us or upgrade to remove branding" :""),a.appendChild(b)
            });